import { Preferences } from '@capacitor/preferences';

import { nativeAppStorageId } from '../native-app-id';

const SESSION_TOKEN_KEY = `${nativeAppStorageId()}_session_token`;

export async function getNativeSessionToken(): Promise<string | null> {
  const { value } = await Preferences.get({ key: SESSION_TOKEN_KEY });
  return value ?? null;
}

export async function setNativeSessionToken(token: string): Promise<void> {
  await Preferences.set({ key: SESSION_TOKEN_KEY, value: token });
}

export async function clearNativeSessionToken(): Promise<void> {
  await Preferences.remove({ key: SESSION_TOKEN_KEY });
}
